export const CANVAS_CONTROL_SCHEME_STORAGE_KEY = "bedrock-canvas-control-scheme-v1";

export type CanvasControlScheme = "classic" | "sebsoto";

export function loadCanvasControlScheme(): CanvasControlScheme {
  if (typeof localStorage === "undefined") return "classic";
  const saved = localStorage.getItem(CANVAS_CONTROL_SCHEME_STORAGE_KEY);
  return saved === "sebsoto" ? "sebsoto" : "classic";
}

export function saveCanvasControlScheme(scheme: CanvasControlScheme): void {
  if (typeof localStorage !== "undefined") localStorage.setItem(CANVAS_CONTROL_SCHEME_STORAGE_KEY, scheme);
}
